var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewConnection(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-289 381 32 32",
    style: {
      enableBackground: "new -289 381 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#74B1E0;}\n\t.st1{fill:#CDE4F7;}\n\t.st2{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-275.4,391.4c-6.2,0-12.7-1.7-12.7-4.8c0-3.2,6.4-4.8,12.7-4.8c6.3,0,12.7,1.6,12.7,4.8 C-262.7,389.7-269.2,391.4-275.4,391.4z M-275.4,383.3c-7,0-11.2,1.9-11.2,3.3s4.3,3.3,11.2,3.3c7,0,11.2-1.9,11.2-3.3 S-268.4,383.3-275.4,383.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-275.4,398.3c-6.2,0-12.7-1.7-12.7-4.8h1.5c0,1.4,4.3,3.3,11.2,3.3c7,0,11.2-1.9,11.2-3.3h1.5 C-262.7,396.6-269.2,398.3-275.4,398.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-275.4,405.2c-6.2,0-12.7-1.7-12.7-4.8h1.5c0,1.4,4.3,3.3,11.2,3.3c0.9,0,1.7,0,2.5-0.1l0.1,1.5 C-273.6,405.2-274.5,405.2-275.4,405.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-275.4,412.2c-6.2,0-12.7-1.7-12.7-4.8v-20.8h1.5c0,1.4,4.3,3.3,11.2,3.3c7,0,11.2-1.9,11.2-3.3h1.5v11.3 h-1.5v-9c-2.3,1.6-6.9,2.4-11.2,2.4c-4.4,0-8.9-0.8-11.2-2.4v18.5c0,1.4,4.3,3.3,11.2,3.3c2.3,0,4.5-0.2,6.5-0.7l0.3,1.5 C-270.6,411.9-273,412.2-275.4,412.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: -265.6,
    cy: 404.5,
    r: 7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-265.6,412.3c-4.3,0-7.8-3.5-7.8-7.8s3.5-7.8,7.8-7.8c4.3,0,7.8,3.5,7.8,7.8 C-257.9,408.8-261.4,412.3-265.6,412.3z M-265.6,398.2c-3.4,0-6.3,2.8-6.3,6.3c0,3.4,2.8,6.3,6.3,6.3c3.4,0,6.3-2.8,6.3-6.3 C-259.4,401-262.2,398.2-265.6,398.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -268.8,
    y: 403.7,
    className: "st0",
    width: 6.3,
    height: 1.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -266.4,
    y: 401.4,
    className: "st0",
    width: 1.5,
    height: 6.3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewConnection);
export default __webpack_public_path__ + "static/media/new_connection.068edf693a9633314a870acbf01cbb72.svg";
export { ForwardRef as ReactComponent };